export enum CertificationStatusWithText {
    NotInitiated = "Not Initiated",
    InitiatedDraft = "Initiated/Draft",
    MissingSignature = "Missing Signature",
    SentForSignature = "Sent for Signature",
    SignatureComplete = "Signature Complete",
    HandSigned = "Hand-Signed",
    Rejected = "Rejected",
    NotRequired = "Not Required",
}

export enum CertificationStatusWithId {
    NotInitiated = 1,
    InitiatedDraft = 2,
    MissingSignature = 3,
    SentForSignature = 4,
    SignatureComplete = 5,
    Rejected = 6,
    HandSigned = 7,
    NotRequired = 8,
}

export enum CertificationDocumentType {
    Initial = 1,
    FirstCert = 2,
    Cert = 3,
    Attestation = 4
}

export enum CertificationMode {
  Edit = 0,
  View = 1
}